"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EntityListTabs = exports.EntityListTabsDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var tabs_1 = require("../elements/tabs");
var tab_1 = require("../elements/tab");
var use_entity_definition_named_1 = require("../../hooks/use-entity-definition-named");
var use_icons_1 = require("../../hooks/use-icons");
var use_lang_1 = require("../../hooks/use-lang");
var sprintf_js_1 = require("sprintf-js");
var entity_create_button_1 = require("./entity-create-button");
// import { EntityDeleteButton } from './entity-create-button';
var lodash_1 = require("lodash");
var menu_button_1 = require("../elements/menu-button");
var icon_button_1 = require("../elements/icon-button");
var use_modal_1 = require("../../hooks/use-modal");
var entity_type_export_layout_1 = require("./entity-type-export-layout");
var current_user_can_1 = require("../../utils/current-user-can");
exports.EntityListTabsDefaultProps = {};
// -------- Child Component Props -------->
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    /* margin-top: 8px; */\n  "], ["\n    /* margin-top: 8px; */\n  "])))
});
var TabStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    text-transform: none;\n    margin-top: 4px;\n    display: none;\n  "], ["\n    text-transform: none;\n    margin-top: 4px;\n    display: none;\n  "]))),
  desktop: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    display: flex;\n  "], ["\n    display: flex;\n  "])))
});
var CreateButtonStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    margin-right: ", ";\n  "], ["\n    margin-right: ", ";\n  "])), theme_1.theme.UNIT(1)),
  desktop: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var MenuButtonStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    display: flex;\n  "], ["\n    display: flex;\n  "]))),
  desktop: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    display: none;\n  "], ["\n    display: none;\n  "])))
});
var ExportButtonStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    margin-right: ", ";\n  "], ["\n    margin-right: ", ";\n  "])), theme_1.theme.UNIT(4))
});
var ExportLayoutStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components -------->
var My = {
  Container: (0, styled_components_1.default)(tabs_1.Tabs)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Tab: (0, styled_components_1.default)(tab_1.Tab)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), TabStyles),
  CreateButton: (0, styled_components_1.default)(entity_create_button_1.EntityCreateButton)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), CreateButtonStyles),
  ExportButton: (0, styled_components_1.default)(icon_button_1.ExportIconButton)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), ExportButtonStyles),
  MenuButton: (0, styled_components_1.default)(menu_button_1.MenuButton)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), MenuButtonStyles),
  ExportLayout: (0, styled_components_1.default)(entity_type_export_layout_1.EntityTypeExportLayout)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), ExportLayoutStyles)
};
var EntityListTabs = function (props) {
  var className = props.className,
    entityTypeName = props.entityTypeName,
    params = props.params;
  var definition = (0, use_entity_definition_named_1.useEntityDefinitionNamed)(entityTypeName);
  var useActive = definition === null || definition === void 0 ? void 0 : definition.useActive;
  var useMembership = definition === null || definition === void 0 ? void 0 : definition.useMembership;
  var useConversation = definition === null || definition === void 0 ? void 0 : definition.useConversation;
  var showConversationsTab = definition === null || definition === void 0 ? void 0 : definition.list.showConversationsTab;
  var modal = (0, use_modal_1.useModal)();
  var exportOnClick = function () {
    modal.show(react_1.default.createElement(My.ExportLayout, {
      entityTypeName: entityTypeName
    }), {
      title: 'Export',
      showCloseButton: true,
      align: 'center'
    });
  };
  var t = (0, use_lang_1.useLang)();
  var toList = definition.toList();
  var Icons = (0, use_icons_1.useIcons)();
  var tabItems = (0, lodash_1.filter)([useActive && {
    isCurrent: !(0, lodash_1.includes)(['all', 'network', 'map', 'conversations'], params),
    to: toList,
    label: (0, sprintf_js_1.sprintf)(t('Active %s'), definition.pluralLabel)
  }, {
    isCurrent: useActive && params === 'all' || !useActive && params === '',
    to: "".concat(toList, "/").concat(useActive ? 'all' : ''),
    label: (0, sprintf_js_1.sprintf)(t('All %s'), definition.pluralLabel)
  }, useConversation && showConversationsTab && {
    isCurrent: params === 'conversations',
    to: "".concat(toList, "/conversations"),
    label: t('With Conversations')
  }, useMembership && {
    isCurrent: params === 'member',
    to: "".concat(toList, "/member"),
    label: t('Members')
  }, definition.useMap && {
    to: "".concat(toList, "/map"),
    icon: Icons.Pin,
    isCurrent: params === 'map',
    label: (0, sprintf_js_1.sprintf)(t('Map'), definition.label)
  }
  // definition.useNetwork && { to: `${toList}/network`, icon: Icons.AppSections.Platform, isCurrent: params === 'network', label: sprintf(t('Network'), definition.label) }
  ]);
  var activeItem = tabItems.find(function (tabItem) {
    return tabItem.isCurrent;
  });
  var canAdmin = (0, current_user_can_1.currentUserCanAdmin)(entityTypeName);
  return react_1.default.createElement(react_1.default.Fragment, null, activeItem && react_1.default.createElement(My.MenuButton, {
    hasMenu: tabItems.length > 1,
    icon: activeItem.icon
  }, activeItem.label), react_1.default.createElement(My.Container, {
    className: className,
    controls: react_1.default.createElement(react_1.default.Fragment, null, canAdmin && react_1.default.createElement(My.ExportButton, {
      onClick: exportOnClick
    }, t('Export')), react_1.default.createElement(My.CreateButton, {
      priority: "icon",
      entityTypeName: entityTypeName
    })),
    items: tabItems.map(function (_a) {
      var isCurrent = _a.isCurrent,
        to = _a.to,
        icon = _a.icon,
        label = _a.label;
      return react_1.default.createElement(My.Tab, {
        isCurrent: isCurrent,
        to: to
      }, label);
    })
  }));
};
exports.EntityListTabs = EntityListTabs;
exports.EntityListTabs.defaultProps = exports.EntityListTabsDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15;